import ImportedComponent0 from "../../../../src/docs/sdk/event-payloads/properties/event_id.mdx";
import ImportedComponent1 from "../../../../src/docs/sdk/event-payloads/properties/tags.mdx";
import * as React from 'react';
export default {
  ImportedComponent0,
  ImportedComponent1,
  React
};